var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPublish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1183_317)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.96843 9.71657C2.04599 9.7816 2.16002 9.77448 2.23159 9.70291L3.3656 8.56891C3.45436 8.48015 3.44009 8.3327 3.34133 8.25522C2.52467 7.61448 2 6.61851 2 5.5C2 3.567 3.567 2 5.5 2C7.09919 2 8.45267 3.07422 8.86846 4.54432L9.23901 5.85443C9.26337 5.94055 9.34197 6 9.43146 6H10.793H11C12.6569 6 14 7.34315 14 9C14 9.68517 13.7703 10.3167 13.3837 10.8218C13.3199 10.9051 13.3235 11.0238 13.3977 11.098L14.5347 12.235C14.6152 12.3154 14.7467 12.3129 14.8202 12.226C15.5563 11.3553 16 10.2295 16 9C16 6.23858 13.7614 4 11 4H10.9442C10.8548 4 10.7765 3.94031 10.7497 3.8549C10.0504 1.62096 7.96451 0 5.5 0C2.46243 0 0 2.46243 0 5.5C0 7.19318 0.7651 8.70766 1.96843 9.71657ZM9 12H10.4792C11.2584 12 11.6694 11.0771 11.1481 10.4979L8.89195 7.99106C8.41526 7.4614 7.58474 7.4614 7.10805 7.99106L4.85186 10.4979C4.33061 11.0771 4.74163 12 5.52083 12H7V15.6C7 15.8209 7.17909 16 7.4 16H8.6C8.82091 16 9 15.8209 9 15.6V12Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1183_317"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublish);
export default __webpack_public_path__ + "static/media/publish.8bd18350bd602f03e999f5858e4227c8.svg";
export { ForwardRef as ReactComponent };